<!--<nav class="navbar navbar-expand-lg navbar-light topbar static-top" style="height: 3rem;">-->

<!--  &lt;!&ndash; Page Heading &ndash;&gt;-->
<!--  <div class="d-sm-flex align-items-center justify-content-between">-->
<!--    &lt;!&ndash; breadcrumb &ndash;&gt;-->
<!--    <a class="navbar-brand brand-name text-primary" routerLink="/">SContract</a>-->
<!--    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"-->
<!--            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">-->
<!--      <span class="navbar-toggler-icon"></span>-->
<!--    </button>-->
<!--  </div>-->

<!--  &lt;!&ndash; Topbar Navbar &ndash;&gt;-->
<!--  <ul class="navbar-nav ml-auto">-->
<!--    &lt;!&ndash; Nav Item - Vietnamese &ndash;&gt;-->
<!--    <li class="nav-item no-arrow mx-1">-->
<!--      <a class="nav-link vt-cursor-pointer" (click)="onChangeLanguage('vi')"-->
<!--         [matTooltip]="'header.vietnamese' | translate"><img class="vt-cursor-pointer"-->
<!--                                                             src="./assets/images/vietnam.png" alt="vietnamese"></a>-->
<!--    </li>-->
<!--    &lt;!&ndash; Nav Item - English &ndash;&gt;-->
<!--    <li class="nav-item no-arrow mx-1">-->
<!--      <a class="nav-link vt-cursor-pointer" (click)="onChangeLanguage('en')"-->
<!--         [matTooltip]="'header.english' | translate"><img class="vt-cursor-pointer"-->
<!--                                                          src="./assets/images/united-kingdom.png" alt="english"></a>-->
<!--    </li>-->
<!--  </ul>-->
<!--</nav>-->

<nav class="navbar navbar-expand-lg navbar-light topbar static-top" style="height: 4rem;">
    <a class="navbar-brand" routerLink="/">
        <img src="./assets/images/home/logo_full_scontract.png" alt="Scontract" width="180">
    </a>
    <!--button show only mobile -->
    <button class="navbar-toggler bg-dark" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
        <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
        <div class="form-inline my-2 my-lg-0">
            <!-- Topbar Navbar -->
  <ul class="navbar-nav ml-auto">
    <!-- Nav Item - Vietnamese -->
    <li class="nav-item no-arrow mx-1">
      <a class="nav-link vt-cursor-pointer" (click)="onChangeLanguage('vi')"
         [matTooltip]="'header.vietnamese' | translate"><img class="vt-cursor-pointer"
                                                             src="./assets/images/vietnam.png" alt="vietnamese"></a>
    </li>
    <!-- Nav Item - English -->
    <li class="nav-item no-arrow mx-1">
      <a class="nav-link vt-cursor-pointer" (click)="onChangeLanguage('en')"
         [matTooltip]="'header.english' | translate"><img class="vt-cursor-pointer"
                                                          src="./assets/images/united-kingdom.png" alt="english"></a>
    </li>
  </ul>
        </div>
    </div>
</nav>
